import React from "react"
import { createIcon } from "@chakra-ui/icons"

export const Ingredients = createIcon({
  displayName: "Ingredients",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img",
  },
  path: (
    <>
      <title> Ingredients icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6 3.23C16.56 3.12 16.47 3.04 16.35 3.01C16.19 2.97 16.02 3.03 15.93 3.17C15.68 3.57 13.5 7.12 13.5 8.75C13.5 10.23 14.68 11.44 16.15 11.49C16.18 11.5 16.21 11.5 16.24 11.5C17.75 11.5 18.98 10.27 18.98 8.76C19 7.19 16.96 3.81 16.6 3.23ZM16.33 10.76C16.3 10.75 16.28 10.75 16.25 10.75C15.15 10.75 14.26 9.85 14.26 8.76C14.26 7.73 15.5 5.4 16.25 4.11C17 5.4 18.25 7.74 18.25 8.77C18.25 9.84 17.39 10.72 16.33 10.76ZM9.88 5.76001C9.71 5.72001 9.54 5.78001 9.45 5.93001C9.27 6.22001 5 13.13 5 16.12C5 18.75 7.14 20.89 9.77 20.89C12.4 20.89 14.54 18.76 14.54 16.14C14.54 13.27 10.58 6.76001 10.12 6.01001C10.09 5.89001 10 5.80001 9.88 5.76001ZM9.77 20.14C7.55 20.14 5.75 18.34 5.75 16.12C5.75 13.8 8.76 8.55001 9.77 6.86001C10.77 8.53001 13.8 13.81 13.8 16.14C13.79 18.34 11.99 20.14 9.77 20.14ZM9.42 18.93V18.04C9.42 17.85 9.57 17.69 9.77 17.65C10.8182 17.5642 11.4397 16.7338 11.5045 16.6472C11.5077 16.6429 11.5095 16.6405 11.51 16.64C11.63 16.47 11.86 16.43 12.03 16.54L12.81 17.06C12.98 17.17 13.02 17.4 12.92 17.57C11.94 19.18 10.35 19.3 9.89 19.3H9.77C9.57 19.29 9.42 19.13 9.42 18.93ZM11.89 17.37C11.59 17.7 11.01 18.2 10.17 18.37V18.54C10.63 18.49 11.45 18.29 12.07 17.49L11.89 17.37Z"
        fill="currentColor"
      />
    </>
  ),
})
